import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { AdminBrand } from './api';

interface BrandChecklistProps {
  /** Brand fra cui scegliere: quelli della company dell'utente. */
  brands: AdminBrand[];
  selected: string[];
  onChange: (next: string[]) => void;
  disabled?: boolean;
}

/**
 * Selezione dei brand visibili a un utente. Puramente presentazionale: la
 * usano sia il form di creazione sia la riga di modifica nella tabella.
 */
export function BrandChecklist({
  brands,
  selected,
  onChange,
  disabled = false,
}: BrandChecklistProps): ReactNode {
  const { t } = useTranslation();

  if (brands.length === 0) {
    return <p className="admin-hint">{t('admin.users.noBrandsForCompany')}</p>;
  }

  function toggle(brandId: string, checked: boolean): void {
    onChange(checked ? [...selected, brandId] : selected.filter((id) => id !== brandId));
  }

  return (
    <div className="admin-toggles">
      {brands.map((brand) => (
        <label key={brand.id} className="admin-toggle">
          <input
            type="checkbox"
            checked={selected.includes(brand.id)}
            disabled={disabled}
            onChange={(e) => toggle(brand.id, e.target.checked)}
          />
          {brand.name}
          <code className="admin-mono">{brand.sector}</code>
        </label>
      ))}
    </div>
  );
}
